<template>
  <br />
  <div class="col-sm-12">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div>
          <h3 class="mb-0">Calendario</h3>
          <small class="text-muted" v-if="nombreOrganizacion">Organización: {{ nombreOrganizacion }}</small>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="volver">
          <vue-feather type="arrow-left" size="14" class="me-1"></vue-feather> Volver
        </button>
      </div>
      <div class="card-body">
        <div v-if="loading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
          <span class="ms-2 text-muted small">Cargando calendario...</span>
        </div>
        <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
        <div v-else-if="!quincenas.length" class="text-center py-4 text-muted">
          No hay calendario configurado para esta organización.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-hover table-sm mb-0">
            <thead class="table-secondary">
              <tr>
                <th>Año</th>
                <th>Mes</th>
                <th class="text-center">Quincena</th>
                <th>Fecha límite</th>
                <th>Fecha inicio</th>
                <th>Fecha fin</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="q in quincenas" :key="q.id">
                <td>{{ q.anio }}</td>
                <td>{{ nombreMes(q.mes) }}</td>
                <td class="text-center">{{ q.quincena }}</td>
                <td class="fw-bold" :class="esVencida(q) ? 'text-danger' : 'text-success'">{{ formatDate(q.fechaLimite) }}</td>
                <td>{{ formatDate(q.fechaInicio) }}</td>
                <td>{{ formatDate(q.fechaFin) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/axios';

const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export default {
  name: 'CalendarioOrganizacion',

  data() {
    return {
      loading: false,
      error: null,
      calendario: [],
      nombreOrganizacion: '',
    };
  },

  computed: {
    quincenas() {
      return this.calendario
        .filter(c => c.isActive !== false)
        .slice()
        .sort((a, b) => a.anio - b.anio || a.mes - b.mes || a.quincena - b.quincena);
    },
  },

  created() {
    this.nombreOrganizacion = this.$route.query.nombre || '';
    this.cargarCalendario();
  },

  methods: {
    async cargarCalendario() {
      const id = this.$route.params.id;
      if (!id) return;
      try {
        this.loading = true;
        this.error = null;
        const res = await api.get(`organizaciones/calendarios/${id}`);
        this.calendario = Array.isArray(res.data) ? res.data : [];
      } catch (err) {
        console.error('Error al cargar el calendario:', err);
        this.error = 'No se pudo cargar el calendario de la organización.';
      } finally {
        this.loading = false;
      }
    },

    nombreMes(mes) {
      return MESES[mes - 1] || `Mes ${mes}`;
    },

    formatDate(val) {
      if (!val) return '—';
      const d = new Date(val);
      if (isNaN(d)) return val;
      const pad = n => String(n).padStart(2, '0');
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    },

    esVencida(q) {
      if (!q.fechaLimite) return false;
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      const limite = new Date(q.fechaLimite);
      limite.setHours(0, 0, 0, 0);
      return hoy > limite;
    },

    volver() {
      this.$router.push({ name: 'organizaciones' });
    },
  },
};
</script>
